<div class="p-fluid grid center-screen" style="min-height: 70vh;">
    <h3><b>404: Parece que la pagina que no existe</b> y Por uqe</h3>
</div>